import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ContenidoNoEncontradoComponent } from './features/contenido-no-encontrado/pages/contenido-no-encontrado/contenido-no-encontrado.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'inicio',
        loadChildren: () =>
          import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'servicios-ciudadania',
        loadChildren: () =>
          import('./features/servicios-ciudadania/servicios-ciudadania.module').then((m) => m.ServiciosCiudadaniaModule),
      },
      {
        path: 'noticias',
        loadChildren: () =>
          import('./features/noticias/noticias.module').then((m) => m.NoticiasModule),
      },
      {
        path: 'normativa',
        loadChildren: () =>
          import('./features/normativa/normativa.module').then((m) => m.NormativaModule),
      },
      {
        path: 'ayuda',
        loadChildren: () =>
          import('./features/ayuda/ayuda.module').then((m) => m.AyudaModule),
      },
      {
        path: 'entidades-participantes',
        loadChildren: () =>
          import('./features/entidades-participantes/entidades-participantes.module').then((m) => m.EntidadesParticipantesModule),
      },
      {
        path: 'info-vital',
        loadChildren: () =>
          import('./features/info-vital/info-vital.module').then((m) => m.InfoVitalModule),
      },
      {
        path: 'registro-usuario',
        loadChildren: () =>
          import('./features/user-sing-in/user-sing-in.module').then((m) => m.UserSingInModule),
      },
      {
        path: 'actualizacion-usuario',
        loadChildren: () =>
          import('./features/user-update/user-update.module').then((m) => m.UserUpdateModule)
      },
      {
        path: 'buscador',
        loadChildren: () =>
          import('./features/buscador/buscador.module').then((m) => m.BuscadorModule),
      },
      {
        path: 'test',
        loadChildren: () =>
          import('./features/test/test.module').then((m) => m.TestModule),
      },
      {
        path: '404',
        loadChildren: () =>
          import('./features/contenido-no-encontrado/contenido-no-encontrado.module').then((m) => m.ContenidoNoEncontradoModule),
      },
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: '404'
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
